// Tùy biến KHCN: nhận diện thương hiệu theo bản thiết kế của lãnh đạo.
// Wordmark ban đầu trên header/footer là năm "2026" (dấu mốc của diễn đàn); sau khi ấn ký "Hà Tĩnh" bay vào,
// header đổi sang tên diễn đàn (xem services/brandIntro.ts). tenant.name vẫn dùng cho <title>, SEO và aria.
export const BRAND_WORDMARK = "2026"

// Liên kết mạng xã hội ở chân trang. Để trống thì icon tương ứng không hiện.
export const BRAND_SOCIAL: { [key: string]: string } = {
  facebook: "",
  youtube: "",
  zalo: "",
}

// Banner trang chủ: "posters" = sân khấu poster sự kiện (market giữa, hai standee diễn giả);
// "slider" = slider danh lam Hà Tĩnh + trống đồng (bản trước, vẫn giữ nguyên code ở HeroBanner.tsx).
export const HERO_VARIANT: "posters" | "slider" = "posters"
